import _ from 'lodash'
import type {SingleComponentPluginFunction} from '../../types'
import type {ComponentWithResolvedDataItems} from '@wix/document-services-types'
import {COMPONENTS_METADATA} from '@wix/format-converter-schemas'
import {ReportableError} from '@wix/document-manager-utils'

const FRIENDLY_TO_COMPONENT_TYPES_MAP = _(COMPONENTS_METADATA)
    .mapValues(({friendlyType}) => friendlyType)
    .invert()
    .value()

export const unpack: SingleComponentPluginFunction = (component: ComponentWithResolvedDataItems): void => {
    if (!component.type) {
        throw new ReportableError({
            errorType: 'CORE_CONVERTER_UNPACK_ERROR',
            message: 'Component does not have a type',
            extras: {
                componentId: component.id
            }
        })
    }

    if (component.componentType) {
        return
    }

    const componentType = FRIENDLY_TO_COMPONENT_TYPES_MAP[component.type]
    if (!componentType) {
        throw new ReportableError({
            errorType: 'CORE_CONVERTER_UNPACK_ERROR',
            message: 'Unknown component type',
            extras: {
                componentId: component.id,
                componentType: component.type
            }
        })
    }

    component.componentType = componentType
    component.type = COMPONENTS_METADATA[componentType].type
}
